import { IS_MIX_CATALOG } from "@/config/browserBoard";
import type { Thread } from "@/entities/thread";
import { appendMixQuery } from "@/shared/lib/mixReturn";

export type ThreadLinkTarget =
  | Readonly<{ kind: "router"; threadId: string }>
  | Readonly<{ kind: "mix-router"; slug: string; threadId: string }>
  | Readonly<{ kind: "board"; href: string }>;

/**
 * タイルの遷移先を決める。総合カタログの取得元板slug `b` 付きスレは
 * mix内の板slug付きスレページへ遷移し、板マウントでは従来どおり
 * 板ネイティブURLへ `?mix=1` を付ける。
 */
export function resolveThreadLinkTarget(
  thread: Pick<Thread, "id" | "b">,
  isMixCatalog: boolean = IS_MIX_CATALOG,
): ThreadLinkTarget {
  if (thread.b === undefined) {
    return { kind: "router", threadId: String(thread.id) };
  }
  if (isMixCatalog) {
    return {
      kind: "mix-router",
      slug: thread.b,
      threadId: String(thread.id),
    };
  }
  return {
    kind: "board",
    href: appendMixQuery(
      `/b/${encodeURIComponent(thread.b)}/thread/${encodeURIComponent(thread.id)}`,
    ),
  };
}
